/*
 * Track order page controller - drives sections/track-order.liquid.
 *
 * Only real data is shown:
 *   - a signed-in customer's own orders (rendered into the page by Liquid):
 *     confirmed / in the workshop / shipped, plus courier, AWB and tracking link;
 *   - any AWB number typed in, which opens Delhivery's own live tracking page
 *     (Delhivery has no embeddable widget).
 * Shopify has no public order-lookup API, so signed-out visitors can't search by
 * order ID; they are pointed to sign in instead of being shown made-up data.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-track]');
  if (!root) return;

  var cfg = { whatsapp: '', loggedIn: false, accounts: false, loginUrl: '', workshop: {}, orders: [] };
  try { cfg = Object.assign(cfg, JSON.parse(root.querySelector('[data-track-config]').textContent)); } catch (e) { /* keep defaults */ }

  var STEPS = ['Confirmed', 'In the workshop', 'Shipped'];
  var LAST = STEPS.length - 1;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  var $ = function (sel) { return root.querySelector(sel); };
  var form = $('[data-track-form]');
  var orderInput = $('[data-track-order]');
  var submitBtn = $('[data-track-submit]');
  var errorBox = $('[data-track-error]');
  var chipsBox = $('[data-track-chips]');
  var resultBox = $('[data-track-result]');
  var statusEl = $('[data-track-status]');
  var shipBox = $('[data-track-ship]');
  var emptyHtml = resultBox.innerHTML;

  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function safeUrl(u) { return typeof u === 'string' && /^https?:\/\//i.test(u) ? u : ''; }
  function norm(s) { return String(s || '').trim().replace(/^#/, '').toUpperCase(); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function money(v) { return '₹' + (Number(v) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function delhiveryUrl(awb) { return 'https://www.delhivery.com/track/package/' + encodeURIComponent(digits(awb)); }
  function waLink(text) {
    try {
      var u = new URL(cfg.whatsapp, location.href);
      u.searchParams.set('text', text);
      return u.toString();
    } catch (e) { return cfg.whatsapp || '#'; }
  }

  var ICON = {
    check: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>',
    truck: '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#F3EADA" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"></path><path d="M14 10h4l3 3v3h-7z"></path><circle cx="7" cy="18.5" r="1.8"></circle><circle cx="17" cy="18.5" r="1.8"></circle></svg>',
    box: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C3AF8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"></path><path d="M3 8l9 5 9-5"></path><path d="M12 13v8"></path></svg>',
    alert: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7.5v5.5"></path><path d="M12 16.4h.01"></path></svg>',
    out: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"></path><path d="M8 7h9v9"></path></svg>'
  };

  /* ---------- Shopify customer order -> display shape ---------- */
  function fromCustomerOrder(o) {
    var ful = o.fulfillments || [];
    var last = ful.length ? ful[ful.length - 1] : null;
    var shipped = ful.length > 0;
    var cancelled = !!o.cancelled;
    var courier = (last && last.company) || (shipped ? 'Courier' : '');
    var awb = (last && last.number) || '';
    var paid = o.financial === 'paid';

    var trackUrl = last && safeUrl(last.url);
    if (!trackUrl && awb && /delhivery/i.test(courier)) trackUrl = delhiveryUrl(awb);

    var payMode = {
      paid: 'Prepaid', pending: 'Cash on delivery', authorized: 'Cash on delivery',
      refunded: 'Refunded', partially_refunded: 'Partly refunded', voided: 'Voided'
    }[o.financial] || 'Payment ' + String(o.financial || 'pending').replace(/_/g, ' ');

    var events = ful.slice().reverse().map(function (f) {
      return {
        title: 'Shipped',
        detail: 'Handed to ' + (f.company || 'the courier') + (f.number ? ' · AWB ' + f.number : '') + '.',
        stamp: f.stamp
      };
    });
    if (cancelled) events.unshift({ title: 'Order cancelled', detail: o.cancelReason || '', stamp: '' });
    events.push({
      title: 'Order confirmed',
      detail: (paid ? 'Payment received.' : 'Order received.') + ' Sent to the workshop queue.',
      stamp: o.stamp
    });

    var line2 = [o.city, [o.province, o.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    var address = [[o.address1, o.address2].filter(Boolean).join(', '), line2].filter(Boolean).join('\n');

    return {
      id: o.id, placed: o.placed,
      stage: cancelled ? -1 : shipped ? LAST : 1,
      cancelled: cancelled,
      statusLabel: cancelled ? 'Cancelled' : shipped ? 'Shipped' : 'In the workshop',
      etaHeadline: cancelled ? 'This order was cancelled' : shipped ? 'On its way to you' : (cfg.workshop.headline || 'In the workshop'),
      etaSub: cancelled ? (o.cancelReason || 'Write to us if you have questions.')
        : shipped ? 'Handed to ' + courier + (trackUrl ? ' · follow it live on the courier’s page' : '')
        : (cfg.workshop.sub || ''),
      courier: courier, awb: awb, trackUrl: trackUrl,
      name: o.name, address: address, phone: o.phone,
      payMode: payMode, total: o.total,
      items: (o.items || []).map(function (it) {
        var variant = it.variant && it.variant !== 'Default Title' ? it.variant : '';
        return {
          name: it.name,
          meta: [variant, it.engraving ? 'Engraved “' + it.engraving + '”' : '', it.qty > 1 ? 'Qty ' + it.qty : ''].filter(Boolean).join(' · '),
          price: it.price, image: it.image
        };
      }),
      events: events
    };
  }

  var orders = (cfg.orders || []).map(fromCustomerOrder);

  /* ---------- rendering ---------- */
  function stepsHtml(o) {
    return STEPS.map(function (label, i) {
      var done = !o.cancelled && i < o.stage;
      var current = !o.cancelled && i === o.stage;
      var state = done ? 'done' : current ? 'current' : 'pending';
      var inOn = !o.cancelled && i > 0 && i <= o.stage;
      var outOn = !o.cancelled && i < o.stage;
      var when = o.cancelled ? '-' : done ? 'Done' : current ? (i === LAST ? 'On its way' : 'Happening now') : 'Pending';
      return '<li class="tk-step is-' + state + '" style="--i:' + i + '"' + (current ? ' aria-current="step"' : '') + '>' +
        '<span class="tk-step__rail" aria-hidden="true">' +
        (i > 0 ? '<span class="tk-seg tk-seg--in' + (inOn ? ' is-on' : '') + '"></span>' : '') +
        (i < LAST ? '<span class="tk-seg tk-seg--out' + (outOn ? ' is-on' : '') + '"></span>' : '') +
        '<span class="tk-dot">' + (done ? ICON.check : '') + '</span></span>' +
        '<span class="tk-step__body"><span class="tk-step__label">' + esc(label) + '</span>' +
        '<span class="tk-step__when">' + when + '</span></span></li>';
    }).join('');
  }

  function resultHtml(o) {
    var pct = o.cancelled ? 0 : Math.round(((o.stage + 0.55) / STEPS.length) * 100);
    var live = !o.cancelled;
    var trackUrl = safeUrl(o.trackUrl);

    var events = o.events.map(function (e) {
      return '<li class="tk-event"><div class="tk-event__mark"><span class="tk-event__dot"></span><span class="tk-event__line"></span></div>' +
        '<div class="tk-event__body"><div class="tk-event__title">' + esc(e.title) + '</div>' +
        (e.detail ? '<div class="tk-event__detail">' + esc(e.detail) + '</div>' : '') +
        (e.stamp ? '<div class="tk-event__stamp">' + esc(e.stamp) + '</div>' : '') + '</div></li>';
    }).join('');

    var items = o.items.map(function (it) {
      var img = safeUrl(it.image);
      return '<li class="tk-item"><div class="tk-item__img">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="74" height="74" loading="lazy">' : ICON.box) + '</div>' +
        '<div class="tk-item__main"><div class="tk-item__name">' + esc(it.name) + '</div>' +
        (it.meta ? '<div class="tk-item__meta">' + esc(it.meta) + '</div>' : '') + '</div>' +
        '<div class="tk-item__price">' + esc(money(it.price)) + '</div></li>';
    }).join('');

    return '<article class="tk-card tk-result" tabindex="-1" aria-label="Order ' + esc(o.id) + '">' +
      '<div class="tk-result__head"><div class="tk-result__top"><div>' +
      '<div class="tk-pill"><span class="tk-pill__dot' + (live ? ' is-live' : ' is-off') + '"></span>' + esc(o.statusLabel) + '</div>' +
      '<div class="tk-eta">' + esc(o.etaHeadline) + '</div>' +
      (o.etaSub ? '<div class="tk-eta-sub">' + esc(o.etaSub) + '</div>' : '') + '</div>' +
      '<div class="tk-result__id"><div class="tk-result__id-k">Order</div><div class="tk-result__id-v">' + esc(o.id) + '</div>' +
      (o.placed ? '<div class="tk-result__id-d">Placed ' + esc(o.placed) + '</div>' : '') + '</div></div></div>' +

      '<div class="tk-result__body"><ol class="tk-steps" aria-label="Order progress">' + stepsHtml(o) + '</ol>' +
      '<div class="tk-bar" role="progressbar" aria-label="Order progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
      '<div class="tk-bar__fill' + (live ? '' : ' is-still') + '" data-w="' + pct + '"></div></div>' +

      (o.courier ?
        '<div class="tk-courier"><div class="tk-courier__who"><div class="tk-courier__icon">' + ICON.truck + '</div><div>' +
        '<div class="tk-courier__name">' + esc(o.courier) + '</div>' +
        (o.awb ? '<div class="tk-courier__awb">AWB ' + esc(o.awb) + '</div>' : '') + '</div></div>' +
        '<div class="tk-courier__actions">' +
        (trackUrl ? '<a class="tk-mini tk-mini--primary" href="' + esc(trackUrl) + '" target="_blank" rel="noopener">Live tracking ' + ICON.out + '</a>' : '') +
        (o.awb ? '<button type="button" class="tk-mini" data-copy-awb="' + esc(o.awb) + '">Copy AWB</button>' : '') +
        '</div></div>' : '') +
      '</div>' +

      (events ? '<div class="tk-section"><h2 class="tk-section__title">Activity</h2><ol class="tk-events">' + events + '</ol></div>' : '') +

      (items ? '<div class="tk-section"><h2 class="tk-section__title">In this shipment</h2><ul class="tk-items">' + items + '</ul>' +
        '<div class="tk-total"><span>Order total' + (o.payMode ? ' · ' + esc(o.payMode) : '') + '</span><span>' + esc(money(o.total)) + '</span></div></div>' : '') +
      '</article>';
  }

  function awbHtml(awb) {
    return '<article class="tk-card tk-result" tabindex="-1" aria-label="AWB ' + esc(awb) + '">' +
      '<div class="tk-result__head"><div class="tk-pill"><span class="tk-pill__dot is-live"></span>Delhivery</div>' +
      '<div class="tk-eta">AWB ' + esc(awb) + '</div>' +
      '<div class="tk-eta-sub">Every scan from pickup to your door, straight from the courier.</div></div>' +
      '<div class="tk-result__body"><div class="tk-result__cta">' +
      '<p>Delhivery’s own page shows exactly where this parcel is right now.</p>' +
      '<a class="tk-btn" href="' + esc(delhiveryUrl(awb)) + '" target="_blank" rel="noopener">Open live tracking</a>' +
      '</div></div></article>';
  }

  function updateSidebar(o) {
    var hasShip = !!(o && (o.name || o.address));
    shipBox.hidden = !hasShip;
    if (hasShip) {
      $('[data-ship-name]').textContent = o.name || '';
      $('[data-ship-addr]').textContent = o.address || '';
      $('[data-ship-phone]').textContent = o.phone || '';
    }
    var ref = o ? 'order ' + o.id : 'my order';
    var whatsapp = $('[data-help="whatsapp"]');
    var damaged = $('[data-help="damaged"]');
    if (whatsapp) whatsapp.href = waLink('Hi, I need help with ' + ref + '.');
    if (damaged) damaged.href = waLink('Hi, a piece from ' + ref + ' arrived damaged. Photos attached.');
  }

  function reveal(html, summary, opts) {
    resultBox.innerHTML = html;
    var card = resultBox.firstElementChild;
    var fill = card.querySelector('.tk-bar__fill');
    // Two frames so the browser paints the empty state first; the stepper
    // rails and the progress bar then fill left to right.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        card.classList.add('is-in');
        if (fill) fill.style.width = fill.getAttribute('data-w') + '%';
      });
    });
    statusEl.textContent = summary;
    if (opts && opts.scroll && window.innerWidth <= 980) {
      card.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  function showOrder(o, opts) {
    reveal(resultHtml(o), 'Order ' + o.id + ': ' + o.statusLabel + '. ' + (o.etaHeadline || ''), opts);
    updateSidebar(o);
    markChips(o.id);
  }

  function showAwb(awb, opts) {
    reveal(awbHtml(awb), 'AWB ' + awb + ' ready to track on Delhivery.', opts);
    updateSidebar(null);
    markChips('');
  }

  function showEmpty() {
    resultBox.innerHTML = emptyHtml;
    updateSidebar(null);
    markChips('');
  }

  /* ---------- errors ---------- */
  function link(href, text, external) {
    return '<a href="' + esc(href) + '"' + (external ? ' target="_blank" rel="noopener"' : '') + '>' + esc(text) + '</a>';
  }
  function showError(html) {
    errorBox.innerHTML = ICON.alert + '<span>' + html + '</span>';
    errorBox.hidden = false;
    // Re-trigger the shake on repeated failures.
    errorBox.style.animation = 'none';
    void errorBox.offsetWidth;
    errorBox.style.animation = '';
  }
  function clearError() { errorBox.hidden = true; errorBox.innerHTML = ''; }

  function failure(kind, key) {
    var wa = link(waLink('Hi, I can’t find ' + (key ? 'order ' + key : 'my order') + ' on the tracking page.'), 'message us on WhatsApp', true);
    if (kind === 'notfound') {
      showError('We couldn’t find ' + esc(key) + ' on your account. Check the ID, paste the AWB number instead, or ' + wa + ' and we’ll dig it out.');
    } else {
      var login = cfg.accounts && cfg.loginUrl ? link(cfg.loginUrl, 'Sign in') + ' to see your orders here, or ' : '';
      showError('Orders can only be looked up once you’re signed in. ' + login + 'paste the AWB number from your shipping update to follow the parcel, or ' + wa + '.');
    }
    showEmpty();
    statusEl.textContent = '';
  }

  /* ---------- lookup ---------- */
  function findOrder(key) {
    var d = digits(key);
    return orders.filter(function (o) {
      var id = norm(o.id);
      return id === key || id.replace(/^[A-Z]+-?/, '') === key || (d.length >= 9 && digits(o.awb) === d);
    })[0];
  }

  function lookup(key) {
    var found = findOrder(key);
    if (found) return { order: found };
    var d = digits(key);
    if (/^\d{10,15}$/.test(d) && d === key.replace(/[\s-]/g, '')) return { awb: d };
    return { error: cfg.loggedIn ? 'notfound' : 'signin' };
  }

  function setBusy(busy) {
    submitBtn.textContent = busy ? 'Tracking…' : 'Track order';
    if (busy) submitBtn.setAttribute('aria-busy', 'true'); else submitBtn.removeAttribute('aria-busy');
  }

  var tracking = false;
  function track() {
    if (tracking) return;
    var key = norm(orderInput.value);
    clearError();
    if (!key) {
      showError('Enter your order ID or AWB number.');
      showEmpty();
      orderInput.focus();
      return;
    }
    tracking = true;
    setBusy(true);
    // A short hold so the button feedback reads as work, not a flicker.
    wait(380).then(function () {
      tracking = false;
      setBusy(false);
      var res = lookup(key);
      if (res.order) showOrder(res.order, { scroll: true });
      else if (res.awb) showAwb(res.awb, { scroll: true });
      else failure(res.error, key);
    });
  }

  /* ---------- chips ---------- */
  function buildChips() {
    if (!orders.length) return;
    chipsBox.innerHTML = '<span>Your orders:</span>' + orders.slice(0, 3).map(function (o) {
      return '<button type="button" class="tk-chip" data-chip="' + esc(o.id) + '" aria-pressed="false">' + esc(o.id) + ' · ' + esc(o.statusLabel.toLowerCase()) + '</button>';
    }).join('');
    chipsBox.hidden = false;
  }
  function markChips(id) {
    Array.prototype.forEach.call(chipsBox.querySelectorAll('[data-chip]'), function (c) {
      c.setAttribute('aria-pressed', String(id !== '' && c.getAttribute('data-chip') === id));
    });
  }

  /* ---------- events ---------- */
  form.addEventListener('submit', function (e) { e.preventDefault(); track(); });

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip]');
    if (chip) {
      var id = chip.getAttribute('data-chip');
      var o = orders.filter(function (x) { return x.id === id; })[0];
      if (o) { orderInput.value = o.id; clearError(); showOrder(o); }
      return;
    }
    var copy = e.target.closest('[data-copy-awb]');
    if (copy) {
      var text = copy.getAttribute('data-copy-awb');
      var done = function () {
        copy.classList.add('is-copied');
        copy.innerHTML = ICON.check + ' Copied';
        clearTimeout(copy._t);
        copy._t = setTimeout(function () { copy.classList.remove('is-copied'); copy.textContent = 'Copy AWB'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) { /* nothing to do */ }
        document.body.removeChild(ta); done();
      }
    }
  });

  /* ---------- first paint ---------- */
  buildChips();
  var qOrder = new URLSearchParams(location.search).get('order');
  if (qOrder) {
    orderInput.value = qOrder;
    track();
  } else if (orders.length) {
    orderInput.value = orders[0].id;
    showOrder(orders[0]);
  } else {
    showEmpty();
  }
})();
